var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { Button } from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var Style = require('./error500_style.module.css');
var Error403 = /** @class */ (function (_super) {
    __extends(Error403, _super);
    function Error403() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            // LogWrite(this.props.jwtData, this.props.username, "", "登出");
            window.sessionStorage.clear();
            // console.log("logout");
        };
        return _this;
    }
    Error403.prototype.render = function () {
        return (React.createElement("div", { className: Style.login_warp },
            React.createElement("div", { className: Style.error_content },
                React.createElement(GridList, { cols: 1, cellHeight: 48, spacing: 32, style: { width: '100%' } },
                    React.createElement(GridListTile, { cols: 1 },
                        React.createElement("div", { className: Style.text }, " \u7CFB\u7D71\u4EE3\u78BC\uFF1A403 ")),
                    React.createElement(GridListTile, { cols: 1 },
                        React.createElement(NavLink, { to: window.sessionStorage.getItem('loginPage') || '/login', key: "0", style: { textDecoration: 'none' } },
                            React.createElement(Button, { variant: "contained", color: "primary", style: { width: '128px' }, onClick: this.handleClick }, "\u56DE\u767B\u5165\u9801")))))));
    };
    return Error403;
}(React.Component));
var mapStateToProps = function () { return ({}); };
var mapDispatchToProps = function (dispatch) {
    var actions = {};
    return {
        actions: bindActionCreators(actions, dispatch),
        dispatch: dispatch,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Error403);
